'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tabs = require('material-ui/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tab = require('material-ui/Tabs/Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _templateWrapper = require('./components/templateWrapper');

var _templateWrapper2 = _interopRequireDefault(_templateWrapper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MarketPlace = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(MarketPlace, _PrismaCmsComponent);

  function MarketPlace() {
    _classCallCheck(this, MarketPlace);

    return _possibleConstructorReturn(this, _PrismaCmsComponent.apply(this, arguments));
  }

  MarketPlace.prototype.render = function render() {
    var _this2 = this;

    var _state$tabIndex = this.state.tabIndex,
        tabIndex = _state$tabIndex === undefined ? "local" : _state$tabIndex;
    var content = null;

    switch (tabIndex) {
      case "local":
        content = this.getLocalTemplates();
        break;
    }

    var tabs = _react2.default.createElement(_Tabs2.default, {
      value: tabIndex,
      onChange: function onChange(event, tabIndex) {
        _this2.setState({
          tabIndex: tabIndex
        });
      }
    }, _react2.default.createElement(_Tab2.default, {
      label: this.lexicon("local"),
      value: 'local'
    }), _react2.default.createElement(_Tab2.default, {
      label: this.lexicon("remote"),
      value: 'remote'
    }));

    return _react2.default.createElement('div', {
      style: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }
    }, content);
  };

  MarketPlace.prototype.getLocalTemplates = function getLocalTemplates() {
    var _props = this.props,
        FrontEditor = _props.FrontEditor,
        activeItem = _props.activeItem;
    return _react2.default.createElement(FrontEditor, {
      inEditMode: false,
      CustomComponents: [_templateWrapper2.default],
      data: {
        object: {
          name: "Section",
          component: "Section",
          props: {
            style: {
              // height: "100",
              flexGrow: 1,
              overflow: "auto"
            }
          },
          components: [{
            "name": "Connector",
            "props": {
              "query": "templatesConnection",
              "filtersname": "mkplace-templates-filters",
              pagevariable: "mkplace-templates-page",
              "first": 5,
              where: {
                component_not: "Page"
              }
            },
            "components": [{
              "name": "Grid",
              "component": "Grid",
              "props": {
                "container": true,
                "spacing": 0
              },
              "components": [{
                "name": "Grid",
                "component": "Grid",
                "props": {
                  "item": true,
                  "xs": 12
                },
                "components": [{
                  "name": "Filters",
                  "component": "Filters",
                  "props": {},
                  "components": []
                }]
              }, {
                "name": "Grid",
                "component": "Grid",
                "props": {
                  "item": true,
                  "xs": 12
                },
                "components": [{
                  "name": "ListView",
                  "component": "ListView",
                  "props": {
                    "spacing": 16
                  },
                  "components": [{
                    "name": "Grid",
                    "component": "Grid",
                    "props": {
                      item: true,
                      xs: 12
                    },
                    "components": [{
                      activeItem: activeItem,
                      FrontEditor: FrontEditor,
                      name: "TemplateWrapper",
                      component: "TemplateWrapper",
                      props: {},
                      components: [{
                        "externalKey": null,
                        "name": "Grid",
                        "description": null,
                        "component": "Grid",
                        "props": {
                          "item": true,
                          "xs": 12
                        },
                        "components": [// {
                          //   "name": "Grid",
                          //   "props": {
                          //     "container": true,
                          //     "spacing": 0,
                          //     "alignItems": "center"
                          //   },
                          //   "components": [
                          //     {
                          //       "name": "Grid",
                          //       "props": {
                          //         "spacing": 0,
                          //         "xs": true,
                          //         "item": true
                          //       },
                          //       "components": [
                          //         {
                          //           "name": "NamedField",
                          //           "props": {
                          //             "name": "name"
                          //           },
                          //           "components": [],
                          //           "component": "NamedField"
                          //         },
                          //         {
                          //           "name": "Tag",
                          //           "props": {
                          //             "tag": "span"
                          //           },
                          //           "components": [
                          //             {
                          //               "name": "Tag",
                          //               "component": "Tag",
                          //               "props": {
                          //                 "text": "/"
                          //               },
                          //               "components": []
                          //             }
                          //           ],
                          //           "component": "Tag"
                          //         },
                          //         {
                          //           "name": "NamedField",
                          //           "props": {
                          //             "name": "component"
                          //           },
                          //           "components": [],
                          //           "component": "NamedField"
                          //         },
                          //         // {
                          //         //   "name": "Button",
                          //         //   "props": {
                          //         //     onClick: event => {
                          //         //       alert("wefwef");
                          //         //     },
                          //         //   },
                          //         //   "components": [
                          //         //     {
                          //         //       "name": "NamedField",
                          //         //       "props": {
                          //         //         "name": "name"
                          //         //       },
                          //         //       "components": [],
                          //         //       "component": "NamedField"
                          //         //     },
                          //         //   ],
                          //         //   "component": "Button"
                          //         // },
                          //       ],
                          //       "component": "Grid"
                          //     },
                          //     {
                          //       "name": "Grid",
                          //       "props": {
                          //         "spacing": 0,
                          //         "item": true
                          //       },
                          //       "components": [
                          //         {
                          //           "name": "CreatedBy",
                          //           "props": {},
                          //           "components": [],
                          //           "component": "CreatedBy"
                          //         }
                          //       ],
                          //       "component": "Grid"
                          //     },
                          //     {
                          //       "name": "Grid",
                          //       "props": {
                          //         "spacing": 0,
                          //         "xs": 12,
                          //         "item": true
                          //       },
                          //       "components": [
                          //         {
                          //           "name": "Typography",
                          //           "component": "Typography",
                          //           "props": {
                          //             "variant": "caption"
                          //           },
                          //           "components": [
                          //             {
                          //               "name": "NamedField",
                          //               "props": {
                          //                 "name": "description"
                          //               },
                          //               "components": [],
                          //               "component": "NamedField"
                          //             },
                          //           ],
                          //         },
                          //       ],
                          //       "component": "Grid"
                          //     }
                          //   ],
                          //   "component": "Grid"
                          // }
                        ],
                        "rank": 0
                      }]
                    }]
                  }]
                }]
              }, {
                "name": "Grid",
                "component": "Grid",
                "props": {
                  "item": true,
                  "xs": 12
                },
                "components": [{
                  "name": "Pagination",
                  "component": "Pagination",
                  "props": {},
                  "components": []
                }]
              }]
            }],
            "component": "Connector"
          }]
        }
      }
    });
  }; // render___() {
  //   return "dsfsdf";
  //   const {
  //   } = this.context;
  //   let list = "sdfdsf";
  //   let templatesGroup = [];
  //   return <div>
  //     {list}
  //     {templatesGroup && templatesGroup.length ?
  //       <div
  //         style={{
  //           position: "absolute",
  //           // border: "1px solid blue",
  //           left: "100%",
  //           top: 0,
  //           height: "100%",
  //           width: "490px",
  //           padding: 15,
  //           zIndex: 1200,
  //           background: "rgba(255, 255, 255, 1)",
  //           overflowY: "auto",
  //         }}
  //       >
  //         <Grid
  //           container
  //         >
  //           <Grid
  //             item
  //             xs
  //           >
  //           </Grid>
  //           <Grid
  //             item
  //           >
  //             <IconButton
  //               onClick={event => {
  //                 this.closeTemplates();
  //               }}
  //             >
  //               <CloseIcon
  //               />
  //             </IconButton>
  //           </Grid>
  //         </Grid>
  //         {templatesGroup.map((n, index) => {
  //           const {
  //             label,
  //             ...component
  //           } = n;
  //           return <div
  //             key={index}
  //             style={{
  //               position: "relative",
  //               borderBottom: index - 1 === templatesGroup.length ? undefined : "1px solid #ddd",
  //               margin: "30px 0",
  //               cursor: "pointer",
  //             }}
  //             onClick={event => {
  //               event.preventDefault();
  //               event.stopPropagation();
  //               if (activeItem) {
  //                 activeItem.addComponent(component);
  //               }
  //               this.closeTemplates();
  //             }}
  //           >
  //             <h3
  //               style={{
  //                 borderBottom: "2px solid #ddd",
  //               }}
  //             >
  //               {label}
  //             </h3>
  //             <FrontEditor
  //               {...other}
  //               inEditMode={false}
  //               data={{
  //                 object: component,
  //               }}
  //             />
  //           </div>;
  //         })}
  //       </div>
  //       : null
  //     }
  //   </div>
  // }


  return MarketPlace;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired,
  activeItem: _propTypes2.default.object.isRequired,
  FrontEditor: _propTypes2.default.func.isRequired
}), _temp);
exports.default = MarketPlace;
module.exports = exports['default'];